var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-view",attrs:{"id":"error-page"}},[_c('h1',[_vm._v("404")]),_c('h2',[_vm._v("Well, this is embarassing.")]),_c('CLink',{staticClass:"contrast-button",attrs:{"to":"/"}},[_vm._v(" return home ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }